import React, {Component} from 'react';

import Checkbox from 'material-ui/Checkbox';
import RadioButton from 'material-ui/RadioButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import ModulesUtils from '../../../../infra/ModulesUtils.js';
import RecurrenceDialogRow from './RecurrenceDialogRow';

const moment = require('moment')

class RecurrenceDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateInfo: JSON.parse(JSON.stringify(props.dateInfo))
    }
  }

  componentWillReceiveProps(nextProps) {
    // Copy the new dateInfo only when the dialog have been opened
    if (nextProps.open && !this.props.open) {
      this.setState({
        dateInfo: JSON.parse(JSON.stringify(nextProps.dateInfo))
      })
    }
  }

  getRecurrence() {
    return this.state.dateInfo.recurrence;
  }

  selectDay(key, isInputChecked) {
    if (!this.getRecurrence().repeatOn) {
      this.getRecurrence().repeatOn = {};
    }
    if (isInputChecked) {
      this.getRecurrence().repeatOn[key] = true;
    } else {
      delete this.getRecurrence().repeatOn[key];
    }
    this.setState({ dateInfo: this.state.dateInfo })
  }

  render() {
    return (
      <Dialog
        title={'Repeat'}
        contentStyle={{ maxWidth: 600 }}
        actions={[
          <FlatButton
            key='done'
            label="Done"
            primary={true}
            onTouchTap={() => {
              this.props.onSave(this.getRecurrence());
              this.props.onClose();
            }}
          />,
          <FlatButton
            key='cancel'
            label="Cancel"
            onTouchTap={this.props.onClose}
          />
        ]}
        modal={false}
        open={this.props.open}
        onRequestClose={this.props.onClose}>

        {
          <div
            style={{ display: 'flex', flexDirection: 'column' }}>

            <RecurrenceDialogRow
              title='Repeats'>
              <SelectField
                value={this.getRecurrence().repeats}
                onChange={(event, index, value) => {
                  this.getRecurrence().repeats = value;
                  if (this.getRecurrence().repeats === 'weekly') {
                    const key = moment(this.getRecurrence().startDate).isoWeekday();
                    this.getRecurrence().repeatOn = { };
                    this.getRecurrence().repeatOn[key] = true;
                  } else {
                    this.getRecurrence().repeatBy = 'dayOfTheMonth';
                  }
                  this.setState({ dateInfo: this.state.dateInfo })
                }}>
                <MenuItem
                  key={1}
                  value={'weekly'}
                  primaryText={'Weekly'}/>
                <MenuItem
                  key={2}
                  value={'monthly'}
                  primaryText={'Monthly'}/>
              </SelectField>
            </RecurrenceDialogRow>

            <RecurrenceDialogRow
              title='Repeat every'>
              <SelectField
                maxHeight={300}
                value={this.getRecurrence().repeatOcurrency}
                onChange={(event, index, value) => {
                  this.getRecurrence().repeatOcurrency = value;
                  this.setState({ dateInfo: this.state.dateInfo })
                }}>
                <MenuItem key={1} value={1} primaryText={'1'}/>
                <MenuItem key={2} value={2} primaryText={'2'}/>
                <MenuItem key={3} value={3} primaryText={'3'}/>
                <MenuItem key={4} value={4} primaryText={'4'}/>
                <MenuItem key={5} value={5} primaryText={'5'}/>
                <MenuItem key={6} value={6} primaryText={'6'}/>
                <MenuItem key={7} value={7} primaryText={'7'}/>
                <MenuItem key={8} value={8} primaryText={'8'}/>
                <MenuItem key={9} value={9} primaryText={'9'}/>
                <MenuItem key={10} value={10} primaryText={'10'}/>
                <MenuItem key={11} value={11} primaryText={'11'}/>
                <MenuItem key={12} value={12} primaryText={'12'}/>
                <MenuItem key={13} value={13} primaryText={'13'}/>
                <MenuItem key={14} value={14} primaryText={'14'}/>
                <MenuItem key={15} value={15} primaryText={'15'}/>
                <MenuItem key={16} value={16} primaryText={'16'}/>
                <MenuItem key={17} value={17} primaryText={'17'}/>
                <MenuItem key={18} value={18} primaryText={'18'}/>
                <MenuItem key={19} value={19} primaryText={'19'}/>
                <MenuItem key={20} value={20} primaryText={'20'}/>

              </SelectField>
              <span>
                {this.getRecurrence().repeats === 'weekly' ? 'weeks' : 'months'}
              </span>
            </RecurrenceDialogRow>

            <RecurrenceDialogRow
              title={'Repeat ' + (this.getRecurrence().repeats === 'weekly' ? 'on' : 'by')}>
              {
                this.getRecurrence().repeats === 'weekly' ? (
                  <div
                    style={{ display: 'flex', flexGrow: 1, flexDirection: 'row' }}>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={7}
                      label={'S'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[7] === true} //per iso conventionality, sunday is 7th day of the week
                      onCheck={(ev, isInputChecked) => this.selectDay(7, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={1}
                      label={'M'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[1] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(1, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={2}
                      label={'T'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[2] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(2, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={3}
                      label={'W'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[3] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(3, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={4}
                      label={'T'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[4] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(4, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={5}
                      label={'F'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[5] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(5, isInputChecked)}/>
                    <Checkbox
                      style={{ display: 'flex', flexGrow: 1 }}
                      key={6}
                      label={'S'}
                      labelPosition="left"
                      checked={this.getRecurrence().repeatOn && this.getRecurrence().repeatOn[6] === true}
                      onCheck={(ev, isInputChecked) => this.selectDay(6, isInputChecked)}/>
                  </div>
                ) : (
                  <div
                    style={{ display: 'flex', flexGrow: 1, flexDirection: 'row' }}>
                    <RadioButton
                      style={{ display: 'flex', flexGrow: 1 }}
                      label="day of the month"
                      checked={this.getRecurrence().repeatBy === 'dayOfTheMonth'}
                      onCheck={() => {
                        this.getRecurrence().repeatBy = 'dayOfTheMonth';
                        this.setState({ dateInfo: this.state.dateInfo })
                      }}/>
                    <RadioButton
                      style={{ display: 'flex', flexGrow: 1 }}
                      label="day of the week"
                      checked={this.getRecurrence().repeatBy === 'dayOfTheWeek'}
                      onCheck={() => {
                        this.getRecurrence().repeatBy = 'dayOfTheWeek';
                        this.setState({ dateInfo: this.state.dateInfo })
                      }}/>
                  </div>
                )
              }
            </RecurrenceDialogRow>

            <RecurrenceDialogRow
              title='Summary'>
              <span
                style={{ fontWeight: 'bold' }}>
                {ModulesUtils.getRecurrenceSummary(this.state.dateInfo)}
              </span>
            </RecurrenceDialogRow>

            <div
              style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row' }}>


            </div>
          </div>
        }
      </Dialog>
    )
  }
}

export default RecurrenceDialog



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/RecurrenceDialog.js